<div class="container">
  <div [innerHTML]="(selectCatalogInfo$ | async)?.description"></div>
</div>
